<template>
    <div class="nameCard">
        <div v-if="$slots['meta']">
            <a class="ellipsis meta">
                <slot name="meta"></slot>
            </a>
            
        </div>
        <div class="nameCardProfile">
            <div class="head-content">
                <template v-if="icon">
                    <img :src="iconPath"></img>
                </template>
                <div class="right-wrapper">
                    <h4 v-if="title" class="">
                        {{title}}
                    </h4>
                    <a class="subtext" v-if="subtitle">
                        {{subtitle}}
                    </a>
                </div>
            </div>
            <p v-if="$slots['default']">
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>
// ion-ios-search
export default {
    props: {
        icon: {
            default: false,
        },
        title: {
            default: false,
        },
        subtitle: {
            default: false,
        },
    },
    computed: {
        iconPath() {
            if (this.icon == false) {
                return false
            } else if (this.icon == 'avatar') {
                return 'static/images/profileDark.svg';
            } else if (this.icon == 'file') {
                return 'static/images/fileIcon.svg';
            } else {
                return this.icon;
            }
        },
    },
}
</script>

<style lang="scss" scoped>

.nameCardProfile {
  margin-top: 2pt;
  margin-bottom: 1em;
  display: inline-block;
  width: 100%;
  max-width: 310px;
  background-color: $light-bg-color;
  padding: 0.6em;
  padding-bottom: 0.2em;
  position: relative;
  /*overflow: hidden;*/
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  -ms-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);

  &:hover {
    @include hover();
  }
}
.sidebar .nameCardProfile {
  display: block;
  max-width: auto;
  max-width: auto;
}
.nameCardProfile .head-content {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
  align-content: flex-start;
  margin-bottom: 0.6em;
}

.nameCard .meta {
  color: $light-bg-color;
}

.nameCardProfile .head-content .right-wrapper {
  width: 100%;

  display: block;
  overflow: hidden;
}

.nameCardProfile .head-content img {
  width: 2em !important;
  height: 2em !important;
  display: inline-block !important;
  margin-right: 1em;
}

.nameCardProfile .right-wrapper h4 {
  display: block;
  margin-bottom: 0.3em;
  width: 100%;
  max-width: 100%;
}

.nameCardProfile p {
  // margin-top: 0.6em;
  padding-right: 1em;
  display: block;
  padding-bottom: 0em;
  margin-bottom: 0em;
}

.sidebar .show-timeline .nameCardProfile:after {
  top: 0px;
  left: calc(-1.8em + 0.5px);
  width: 10px;
  height: 10px;
  position: absolute;
  border-radius: 2em;
  background-color: white;
  content: "";
  display: block;
  line-height: 1;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  -ms-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15); 
}

.sidebar .show-timeline .nameCardProfile:before {
  top: -5px;
  left: calc(-2.1em + 0.5px);
  width: 20px;
  height: 20px;
  position: absolute;
  background-color: $darker-bg-color;
  content: "";
}
</style>



// WEBPACK FOOTER //
// src/components/general/card.vue